import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { PurchasePage } from "./purchase/PurchasePage";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/^\/purchase\/?$/.test(window.location.pathname) ? <PurchasePage /> : <App />}
  </StrictMode>,
);
